import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { setStorage } from 'utilz';

import PhoneInput from './components/PhoneInput';
import PhoneConfirmation from './components/PhoneConfirmation';

import containerActions from './actions';
// eslint-disable-next-line
import { URLS } from 'config';

import './styles.scss';

class PhonePage extends React.Component {
  componentWillUnmount() {
    if (this.props.phoneComfirmed) {
      this.props.phoneComfrimation();
      this.props.phoneCodeConfirmChange();
    }
  }

  phoneReceiveHandl = login => () => {
    this.props.phoneSend(this.props.phoneComfrimation, !!this.props.handlAfterSuccess);

    if (login) {
      this.props.phoneComfrimation();
      this.props.phoneCodeConfirmChange();
    }
    if (!this.props.handlAfterSuccess) {
      setStorage({
        phone: {
          phone: this.props.phone
        }
      });
    }
  }

  codeReceiveHandl = () => {
    const nextHandl = this.props.handlAfterSuccess ? this.props.handlAfterSuccess : this.goNext;
    this.props.codeSend(nextHandl, !!this.props.handlAfterSuccess);
  }

  goNext = () => {
    // this.props.history.push(URLS.NAME);
  }

  inputChangeHandl = (e) => {
    const { target: { value } } = e;
    this.props.phoneChange(value.replace(/[/ ()-]/g, ''), value);
  }

  inputConfirmationHandl = (phoneCode) => {
    this.props.phoneCodeConfirmChange(phoneCode);
  }

  editPhoneHandl = number => () => {
    this.props.phoneChange(number.replace(/[/ ()-]/g, ''), number);
    this.props.phoneCodeConfirmChange(['']);
    this.props.phoneComfrimation();
  }

  renderPhoneInput = () => (
    <PhoneInput
      phone={this.props.phone}
      inputChangeHandl={this.inputChangeHandl}
      phoneReceiveHandl={this.phoneReceiveHandl(false)}
    />
  )

  renderPhoneConfirmation = () => (
    <PhoneConfirmation
      purePhone={this.props.phone}
      inputChangeHandl={this.inputConfirmationHandl}
      phoneCode={this.props.phoneCodeConfirm}
      editPhone={this.editPhoneHandl}
      receivedAgainHandl={this.phoneReceiveHandl(true)}
      receiveHandl={this.codeReceiveHandl}
      expectedCode={this.props.expectedCode}
      start={Date.now()}
    />
  )

  render() {
    return (
      <div className="page-phone -not-full">
        {
          !this.props.phoneComfirmed ? this.renderPhoneInput() : this.renderPhoneConfirmation()
        }
      </div>
    );
  }
}

PhonePage.defaultProps = {
  handlAfterSuccess: false
};

PhonePage.propTypes = {
  phoneComfirmed: PropTypes.bool.isRequired,
  phoneComfrimation: PropTypes.func.isRequired,
  phoneChange: PropTypes.func.isRequired,
  phoneCodeConfirmChange: PropTypes.func.isRequired,
  phoneSend: PropTypes.func.isRequired,
  codeSend: PropTypes.func.isRequired,
  phone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  // purePhone: PropTypes.string.isRequired,
  expectedCode: PropTypes.string.isRequired,
  handlAfterSuccess: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  phoneCodeConfirm: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired,
  // eslint-disable-next-line
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  phoneComfirmed: state.phone.phoneComfirmed,
  phone: state.phone.phone,
  purePhone: state.phone.purePhone,
  phoneCodeConfirm: state.phone.phoneCodeConfirm,
  expectedCode: state.phone.expectedCode
});

export default connect(mapStateToProps, containerActions)(PhonePage);



// WEBPACK FOOTER //
// ./src/pages/Phone/index.js